import React, { useEffect, useRef } from 'react'
import { requestTracker } from '../hooks/useRequestTracker'

interface RequestTrackerProviderProps {
  children: React.ReactNode
}

export const RequestTrackerProvider: React.FC<RequestTrackerProviderProps> = ({
  children,
}) => {
  const beforeUnloadHandler = useRef<(event: BeforeUnloadEvent) => void>()

  useEffect(() => {
    beforeUnloadHandler.current = (event: BeforeUnloadEvent) => {
      const hasRequests = requestTracker.hasActiveRequests()

      if (hasRequests) {
        const message =
          'You have unsaved changes. Are you sure you want to leave?'
        event.preventDefault()
        event.returnValue = message
        return message
      }
    }

    window.addEventListener('beforeunload', beforeUnloadHandler.current)

    return () => {
      if (beforeUnloadHandler.current) {
        window.removeEventListener('beforeunload', beforeUnloadHandler.current)
      }
    }
  }, [])

  return <>{children}</>
}
